import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import GlobalErrorModal from './GlobalErrorModal';
import dismissGlobalError from '../actions/dismissGlobalError';

const mapStateToProps = state => ({
  hasGlobalError: state.estimateBuilder.uiState.hasGlobalError,
  errorMessage: state.estimateBuilder.uiState.errorMessage,
  reloadOnClose: state.estimateBuilder.uiState.reloadOnGlobalError,
});

const mapDispatchToProps = dispatch => bindActionCreators({ dismissGlobalError }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(GlobalErrorModal);
